import FancyMarket from '../normal/FancyMarket'

/**
 * Fancy market (mname === "fancy1") — reference `.market-6` fancy block.
 */
function Fancy({ onBetLockClick, marketsData = [], exposureData = {}, index }) {
  return (
    <FancyMarket
      marketName="fancy1"
      betLockName="fancy1"
      layout="backlay"
      index={index ?? 2}
      onBetLockClick={onBetLockClick}
      marketsData={marketsData}
      exposureData={exposureData}
    />
  )
}

export default Fancy
